/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Test_TitleInputs */

const th_meeting_test_title = /** @type {(inputs: Meeting_Test_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทดสอบการประชุม`)
};

const en_meeting_test_title = /** @type {(inputs: Meeting_Test_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meeting test`)
};

const ja_meeting_test_title = /** @type {(inputs: Meeting_Test_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ミーティングテスト`)
};

const zh_meeting_test_title = /** @type {(inputs: Meeting_Test_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会议测试`)
};

const es_meeting_test_title = /** @type {(inputs: Meeting_Test_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prueba de reunión`)
};

const pt_meeting_test_title = /** @type {(inputs: Meeting_Test_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teste de reunião`)
};

const id_meeting_test_title = /** @type {(inputs: Meeting_Test_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uji pertemuan`)
};

const fr_meeting_test_title = /** @type {(inputs: Meeting_Test_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test de réunion`)
};

const tl_meeting_test_title = /** @type {(inputs: Meeting_Test_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagsubok sa miting`)
};

const vi_meeting_test_title = /** @type {(inputs: Meeting_Test_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thử cuộc họp`)
};

const ko_meeting_test_title = /** @type {(inputs: Meeting_Test_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`회의 테스트`)
};

const de_meeting_test_title = /** @type {(inputs: Meeting_Test_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meeting-Test`)
};

const ru_meeting_test_title = /** @type {(inputs: Meeting_Test_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверка встречи`)
};

const tr_meeting_test_title = /** @type {(inputs: Meeting_Test_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toplantı testi`)
};

const it_meeting_test_title = /** @type {(inputs: Meeting_Test_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prova riunione`)
};

const pl_meeting_test_title = /** @type {(inputs: Meeting_Test_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test spotkania`)
};

const uk_meeting_test_title = /** @type {(inputs: Meeting_Test_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перевірка зустрічі`)
};

const hi_meeting_test_title = /** @type {(inputs: Meeting_Test_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बैठक परीक्षण`)
};

const ar_meeting_test_title = /** @type {(inputs: Meeting_Test_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اختبار الاجتماع`)
};

const ms_meeting_test_title = /** @type {(inputs: Meeting_Test_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ujian mesyuarat`)
};

const bn_meeting_test_title = /** @type {(inputs: Meeting_Test_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সভা পরীক্ষা`)
};

const zh_tw2_meeting_test_title = /** @type {(inputs: Meeting_Test_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`會議測試`)
};

const zh_hk2_meeting_test_title = /** @type {(inputs: Meeting_Test_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`會議測試`)
};

const ur_meeting_test_title = /** @type {(inputs: Meeting_Test_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ملاقات کا ٹیسٹ`)
};

const fa_meeting_test_title = /** @type {(inputs: Meeting_Test_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آزمون جلسه`)
};

const sw_meeting_test_title = /** @type {(inputs: Meeting_Test_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jaribio la mkutano`)
};

const nl_meeting_test_title = /** @type {(inputs: Meeting_Test_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesprekstest`)
};

/**
* | output |
* | --- |
* | "Meeting test" |
*
* @param {Meeting_Test_TitleInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_test_title = /** @type {((inputs?: Meeting_Test_TitleInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Test_TitleInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_test_title(inputs)
	if (locale === "ja") return ja_meeting_test_title(inputs)
	if (locale === "zh") return zh_meeting_test_title(inputs)
	if (locale === "es") return es_meeting_test_title(inputs)
	if (locale === "pt") return pt_meeting_test_title(inputs)
	if (locale === "id") return id_meeting_test_title(inputs)
	if (locale === "fr") return fr_meeting_test_title(inputs)
	if (locale === "tl") return tl_meeting_test_title(inputs)
	if (locale === "vi") return vi_meeting_test_title(inputs)
	if (locale === "ko") return ko_meeting_test_title(inputs)
	if (locale === "de") return de_meeting_test_title(inputs)
	if (locale === "ru") return ru_meeting_test_title(inputs)
	if (locale === "tr") return tr_meeting_test_title(inputs)
	if (locale === "it") return it_meeting_test_title(inputs)
	if (locale === "pl") return pl_meeting_test_title(inputs)
	if (locale === "uk") return uk_meeting_test_title(inputs)
	if (locale === "hi") return hi_meeting_test_title(inputs)
	if (locale === "ar") return ar_meeting_test_title(inputs)
	if (locale === "ms") return ms_meeting_test_title(inputs)
	if (locale === "bn") return bn_meeting_test_title(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_test_title(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_test_title(inputs)
	if (locale === "ur") return ur_meeting_test_title(inputs)
	if (locale === "fa") return fa_meeting_test_title(inputs)
	if (locale === "sw") return sw_meeting_test_title(inputs)
	if (locale === "nl") return nl_meeting_test_title(inputs)
	return en_meeting_test_title(inputs)
});